import { createContext, useContext, useRef } from "react";
import { ConfirmDialogHost } from "../components/ConfirmDialog";

const ConfirmContext = createContext(() => Promise.resolve(false));

export function ConfirmProvider({ children }) {
  const ref = useRef(() => Promise.resolve(false));
  const confirm = (opts) => ref.current(opts);
  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <ConfirmDialogHost apiRef={ref} />
    </ConfirmContext.Provider>
  );
}

export const useConfirm = () => useContext(ConfirmContext);
